module.exports = __webpack_public_path__ + "static/media/bomb.2150b325.png";